export const MUTATION_KEY = {
    PAIR_REGISTER: 'pair-register',
} as const;

export type MutationKey = (typeof MUTATION_KEY)[keyof typeof MUTATION_KEY];

const CUSTOMER_BASE = ['customers'];

export const QUERY_KEYS = {
    DOWNLOAD_URLS: 'app-download-urls',
    GET_SALE: 'sale',
    GET_OUTSTANDING_SALES: 'outstanding-sales',
    GET_SALE_RECEIPT_REPRINTS: 'sale-receipt-reprint',
    GET_PAGINATED_CUSTOMERS: 'customers',
    GET_CUSTOMER: 'customer',
    GET_TERMINALS: 'terminals',
    GET_LEDGER: 'ledger',
    GET_WALLET_TRANSACTIONS: 'wallet-transactions',
    GET_LOYALTY_LEDGERS: 'loyalty-ledgers',
    GET_PAGINATED_SAVED_CARTS: 'paginated-saved-carts',
    GET_SAVED_CART: 'saved-cart',
    GET_ACCOUNT_TRANSACTION_HISTORY: 'account-transaction-history',
    GET_CARD_TRANSACTIONS: 'card-transactions',
    GET_TRANSFER_TRANSACTIONS: 'transfer-transactions',
    VALIDATE_TRANSACTION_REFERENCE: 'validate-transaction-reference',
    VALIDATE_TRANSACTION_REFERENCES: 'validate-transaction-references',
    GET_COLLECTION_ACCOUNT: 'collection-account',
    GET_REFUNDS: 'refunds',
    GET_REFUND_STATS: 'refund-stats',
    GET_REFUNDABLE_ITEMS: 'refundable-items',
    GET_REFUNDED_ITEMS: 'refunded-items',
    GET_SALE_PAYMENTS: 'get-sale-payments',
    GET_BUSINESS_PROPERTY: 'business-property',
    GET_SALES_BY_PAYMENT_METHOD: 'GET_SALES_BY_PAYMENT_METHOD',
    GET_SALES_SUMMARY: 'GET_SALES_SUMMARY',
    GET_SALES_BY_ITEM: 'GET_SALES_BY_ITEM',
    GET_SALES_BY_CATEGORY: 'GET_SALES_BY_CATEGORY',
    ITEM_SEARCH_RESULT: 'ITEM_SEARCH_RESULT',
    CUSTOMERS: {
        ALL: CUSTOMER_BASE,
        LIST: [...CUSTOMER_BASE, 'list'],
        DETAIL: (customerId: string) => [
            ...CUSTOMER_BASE,
            'detail',
            customerId,
        ],
    },
    GET_REGISTER_PAYMENT_METHOD_LIST: 'register-payment-method-list',
};

export function getCustomerQueryName(customerId?: string) {
    return `CUSTOMER_${customerId}`;
}
